import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
    tariff_list: [],
    balanceModalIsOpen: false,
};

export default {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
}
